import "./Card.css";
import selectedmvocicon from "../../../../assets/images/selectedmvoc-icon.svg";
import selectedSMSicon from "../../../../assets/images/selectedSMA-icon.svg";
import selectedDigitalicon from "../../../../assets/images/selecteddigital-icon.svg";
import selectedPLSicon from "../../../../assets/images/selectedPLS-icon.svg";
import mvocicon from "../../../../assets/images/mvoc-icon.svg";
import SMSicon from "../../../../assets/images/SMA-icon.svg";
import Digitalicon from "../../../../assets/images/digital-icon.svg";
import PLSicon from "../../../../assets/images/PLS-icon.svg";


const imageMap = {
    "MVOC Insights": {
      selected: selectedmvocicon,
      unselected: mvocicon,
    },
    "Social Media Analysis": {
      selected: selectedSMSicon,
      unselected: SMSicon,
    },
    "Digital Source": {
      selected: selectedDigitalicon,
      unselected: Digitalicon,
    },
    SLR: {
      selected: selectedPLSicon,
      unselected: PLSicon,
    },
  };

const Card = ({
  name,
  details,
  isChecked,
  isDisabled,
  onChange,
}) => {
    // Choose the correct image based on `isChecked`
  const imageSrc = isChecked ? imageMap[name].selected : imageMap[name].unselected;
  return (
    <label className="cardinsight">
      <input
        name="plan"
        className="radio"
        type="radio"
        checked={isChecked}
        disabled={isDisabled}
        onChange={onChange}
      />

      <span className="plan-details">
        <div className="">
          <img src={imageSrc} alt="insight" />
        </div>
        <div className="content">
          <span className="plan-type">{name}</span>
          <span className="details">{details}</span>
        </div>
      </span>
    </label>
  );
};

export default Card;
